
import Vue from "vue";
export default Vue.extend({
  name: "CreateAffiliateRequest",
  props: {
    registration: { type: Object },
  },
});
